// Where to send a creator after they sign in, when signing in was a detour.
//
// Only one detour exists today: an AI app sends the creator to
// /connect/authorize?..., they are not signed in, so they go to /login and
// must land back on the consent screen afterwards, not on /dashboard.
//
// Two guards, because this value decides a navigation:
//   - only same-site paths under /connect/ are accepted, so nothing can turn
//     this into an open redirect;
//   - it expires, so an abandoned connect attempt cannot hijack a normal
//     sign-in later in the same tab.
import { safeSessionStorage } from './safeStorage';

const KEY = 'ml_return_to';
const MAX_AGE_MS = 15 * 60 * 1000;

const isAllowed = (path) => typeof path === 'string' && path.startsWith('/connect/') && !path.startsWith('//');

export const saveReturnTo = (path) => {
  if (!isAllowed(path)) return;
  safeSessionStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
};

export const peekReturnTo = () => {
  try {
    const saved = JSON.parse(safeSessionStorage.getItem(KEY) || 'null');
    if (saved && isAllowed(saved.path) && Date.now() - saved.at < MAX_AGE_MS) return saved.path;
  } catch (_) { /* corrupt value: treat as absent */ }
  return null;
};

export const clearReturnTo = () => safeSessionStorage.removeItem(KEY);
